export const environment = {
  production: false,
  apiUrl: '',
  documentGeneratorApiUrl: 'https://smzh-sf.360net.ch/api',
  cmsOrigin: 'https://staging.cms.smzh.ch/api',
  firebase: {
    apiKey: "AIzaSyBpHUi4roh2wwIBVdpGZ_7yu6P-eX-pwZk",
    authDomain: "client-portal-staging-664b1.firebaseapp.com",
    projectId: "client-portal-staging-664b1",
    storageBucket: "client-portal-staging-664b1.firebasestorage.app",
    messagingSenderId: "118148108020",
    appId: "1:118148108020:web:f91a5402c1f46055d518a1",
    measurementId: "G-QMSGFYZGR9",
    vapidKey: "BKWlk1QTBqwb-7xwDm-_nI8PMrnbq_Jp30zcvPJxZT670YFCFXiVTs78jNPNqaSuMxIHBJvdeQlnlk7tjzGbhtE"
  }
};
